import React from "react"
import PropTypes from "prop-types"
import { graphql, useStaticQuery } from "gatsby"

export const RestaurantContext = React.createContext(null)

const Restaurant = ({ children }) => {
  const { config } = useStaticQuery(graphql`
    query {
      config: contentfulRestaurant(name: { eq: "Azalea Bar & Kitchen" }) {
        hours
        temporarilyClosed
      }
    }
  `)

  return (
    <RestaurantContext.Provider value={{ ...config }}>
      {children}
    </RestaurantContext.Provider>
  )
}

Restaurant.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Restaurant
